export const MIN_PRICE_RANGE = 0;
export const MAX_PRICE_RANGE = 1000000;
export const PRICE_RANGE_STEP = 10000;
